/**
 * One renderer per request kind. Must match core's validators (`core/src/requests.ts`);
 * `registry.test.ts` checks both ends. Build only kinds a shipped game uses.
 */

import { ChoiceInput } from './inputs/ChoiceInput';
import { NoneInput } from './inputs/NoneInput';
import { NumberInput } from './inputs/NumberInput';
import { PressInput } from './inputs/PressInput';
import { TextInput } from './inputs/TextInput';
import { WagerInput } from './inputs/WagerInput';
import { PickParticipantInput } from './inputs/PickParticipantInput';
import { VerdictCard } from './decisions/VerdictCard';
import { GradeListCard } from './decisions/GradeListCard';
import { entry, type Renderer } from './renderer';

/** Keyed by `spec.kind`, not split by surface, so tray and phone can't drift apart. */
export const RENDERERS: Readonly<Record<string, Renderer>> = {
  none: entry(NoneInput),
  press: entry(PressInput),
  text: entry(TextInput),
  number: entry(NumberInput),
  wager: entry(WagerInput),
  choice: entry(ChoiceInput),
  pickParticipant: entry(PickParticipantInput),
  verdict: entry(VerdictCard),
  gradeList: entry(GradeListCard),
};

export function rendererFor(kind: string): Renderer | null {
  return RENDERERS[kind] ?? null;
}
